<template>
  <div id="app">
    <Track />
  </div>
</template>

<script>
import Track from './components/Track.vue';

export default {
  name: 'App',
  components: { Track }
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

body {
    margin: 0;
}
</style>